import './CmsImageHeader.css';
import { CmsMeta } from '../cmsMeta';

type CmsImageHeaderProps = {
	img: string;
	imgMobile: string;
	link?: string;
	className?: string;
};
export const CmsImageHeader = ({ img, imgMobile, link, className }: CmsImageHeaderProps): JSX.Element => {
	return (
		<div className={`cms-image-header ${className ?? ''}`}>
			<a href={link}>
				<img src={img} alt="image" className="desktop-img" />
				<img src={imgMobile} alt="image smal" className="mobile-img" />
			</a>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A full-width picture at the top of a page, with a separate crop for mobile, optionally linking somewhere. `img` is shown on desktop and `imgMobile` on narrow screens; give both. `link` is a path on the site - leave it out for a picture that leads nowhere, since an empty one reloads the page.',
	example: [
		'CmsImageHeader',
		{
			img: 'https://cdn.ondio.com/assets/7f6247c2face42939f0438f7089ad47c.jpg',
			imgMobile: 'https://cdn.ondio.com/assets/3516ddf207ec44eb9eac14c3333e99a7.jpg',
			link: '/varemerker/tork',
		},
	],
};
